/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrderLastPendingFeedbackQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type OrderLastPendingFeedbackQuery = {
  readonly __typename?: 'Query';
  readonly orderLastPendingFeedback: {
    readonly __typename?: 'Order';
    readonly id: string;
  } | null;
};

export const orderLastPendingFeedbackQueryMock: ExecutionResult<OrderLastPendingFeedbackQuery> =
  {
    data: {
      orderLastPendingFeedback: { id: 'e509e6ea-9fee-442a-9962-587ce7190430' },
    },
  };

export const OrderLastPendingFeedbackDocument = gql`
  query OrderLastPendingFeedback {
    orderLastPendingFeedback {
      id
    }
  }
`;

export function useOrderLastPendingFeedbackQuery(
  options?: Omit<
    Urql.UseQueryArgs<OrderLastPendingFeedbackQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    OrderLastPendingFeedbackQuery,
    OrderLastPendingFeedbackQueryVariables
  >({ query: OrderLastPendingFeedbackDocument, ...options });
}
